<template>
    <div class="con-list base-info">
		<van-field
            label="缴纳地"
            v-model="applyData.socialInsuranceLocationDescr"
            readonly
		/>
        <van-field
            label-width="180px"
            label="是否转正后缴纳公积金">
			<template #input>
				<van-switch
                    disabled
                    class="filed-switch"
                    v-model="applyData.beRegularEmpPay"
                    active-value="Y"
                    inactive-value="N"
                    inactive-color="#f2f4f6"
                    active-color="#13ce66"/>
			</template>
		</van-field>
        <van-field
            label="社保基数"
            :value="applyData.socialInsuranceBase | transferValue"
            readonly
		/>
        <!-- <van-field
            label-width="180px"
            label="是否只缴纳意外险">
			<template #input>
				<van-switch
                    disabled
                    class="filed-switch"
                    v-model="applyData.accidentInsurance"
                    active-value="Y"
                    inactive-value="N"
                    inactive-color="#f2f4f6"
                    active-color="#13ce66"/>
			</template>
		</van-field> -->
        <van-field
            label="公积金基数"
            :value="applyData.houseAccFundBaseMax"
            readonly
		/>
        <!-- <van-field
            label-width="180px"
            label="是否缴纳意外险加补充医疗">
			<template #input>
				<van-switch
                    disabled
                    class="filed-switch"
                    v-model="applyData.accidentInsuranceMedicine"
                    active-value="Y"
                    inactive-value="N"
                    inactive-color="#f2f4f6"
                    active-color="#13ce66"/>
			</template>
		</van-field> -->
	</div>
</template>

<script>
export default {
    name: 'm-social',
    props: ['applyData'],
    filters: {
        transferValue(value) {
            return {
                'MIN': '当地下限',
                'SAL': '按工资总额',
            }[value]
        },
    },
}
</script>

<style lang="scss">
.filed-switch{
    margin-right: 16px;
}
</style>